export default __webpack_public_path__ + "static/media/ProfileWhite.2a05716b.svg";